import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Menu } from '@tencent/spaui';
import { connect } from 'react-redux';

console.log('Menu', Menu._version);

class SidebarMenu extends Component {
  shouldComponentUpdate(nextProp) {
    if (nextProp.value !== this.props.value || nextProp.tabValue === '') {
      return true;
    }
    return false;
  }
  render() {
    const { Data, value, onChange, tabValue } = this.props;
    return (
      <aside className="sidebar" id="sidebar">
        <Menu toggle={false} fixed={false} value={+value} onChange={onChange} data={Data} style={{ overflowY: 'scroll' }} />
      </aside>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    accountInfo: state.knowledge.knowledge_info,
    searchVal: state.knowledge.knowledge_search,
    navlist: state.knowledge.knowledge_list,
  };
}
export default withRouter(connect(mapStateToProps)(SidebarMenu));
